export const SET_SNACKBAR = 'SNACKBAR/SET_SNACKBAR'
export const REMOVE_SNACKBAR = 'SNACKBAR/REMOVE_SNACKBAR'